import React from 'react';

import DelayedAccessAlert, {
  Location
} from '@buyside/components/presentation/AccessControl/delayedAccessAlert';
import ResearchItem, {
  ResearchTypes
} from '@buyside/components/presentation/ResearchItem/researchItem';
import ResearchItemLoading from '@buyside/components/presentation/ResearchItem/researchItemLoading';

import { usePostRelatedResearchQuery } from '@interfaces/graphql-typings';

import styles from '@buyside/components/presentation/PostShow/postShowStyles.scss';

const RelatedResearch: React.FC<{ postId: string }> = ({ postId }) => {
  const { data, loading, error } = usePostRelatedResearchQuery({ variables: { postId } });

  if (loading || !data)
    return (
      <>
        <div className={styles.researchHeading}>
          <div>You may also enjoy</div>
        </div>
        <ResearchItemLoading times={5} narrow />
      </>
    );

  if (error || !data.post || !data.currentUser) throw error;

  const { post, currentUser } = data;
  const { id: currentUserId, canViewUserDetails } = currentUser;

  return (
    <>
      <div className={styles.researchHeading}>
        <div>You may also enjoy</div>
      </div>
      <DelayedAccessAlert id={Location.postRelatedIdeas} customStyles={styles.alertPersistent} />
      {post?.relatedIdeas?.edges?.length ? (
        <>
          {post.relatedIdeas.edges.map(edge => {
            const ideaAuthorId = edge?.node?.user?.id;
            return (
              edge?.node &&
              ideaAuthorId && (
                <div className={styles.ideaCardWrap} key={edge.node.id}>
                  <ResearchItem
                    {...edge.node}
                    researchType={ResearchTypes.IDEA}
                    narrow
                    showUserDetails={
                      canViewUserDetails ||
                      ideaAuthorId === currentUserId ||
                      edge?.node?.isNonBuyside
                    }
                  />
                </div>
              )
            );
          })}
        </>
      ) : (
        <div>No recommended research available. Check back later.</div>
      )}
    </>
  );
};

export default RelatedResearch;
